export default __webpack_public_path__ + "static/media/etisalat_new.fae64cb9.jpeg";